import { createRoot } from 'react-dom/client';
import styled from 'styled-components';
import ClickableContainer from '../pages/h_cctv/RealtimeCCTV/ClickableContainer';
import TableLamp from './TableLamp';

class CustomCircleChkRenderer {
  element;

  constructor(props: any) {
    this.element = document.createElement('div');
    const root = createRoot(this.element);

    root.render(
      <div>
        <ClickableContainer button={<TableLamp use={props.value !== 'N'} />} onClick={() => {}} />
      </div>
    );
  }

  getElement() {
    return this.element;
  }
}
export default CustomCircleChkRenderer;
